//parkEmployeeCreateReducer.js
import {
  FETCH_PARK_DETAILS_REQUEST,
  FETCH_PARK_DETAILS_SUCCESS,
  FETCH_PARK_DETAILS_FAILURE,
  CREATE_PARK_USER_REQUEST,
  CREATE_PARK_USER_SUCCESS,
  CREATE_PARK_USER_FAILURE,
} from "../actions/ParkUserCreateActions";

const initialState = {
  // Park Details State
  parkDetails: [],
  parkDetailsLoading: false,
  parkDetailsError: null,

  // Create Park User State
  createdUser: null,
  createUserLoading: false,
  createUserError: null,
};

const parkUserReducer = (state = initialState, action) => {
  switch (action.type) {

    /* =========================================
       FETCH PARK DETAILS
    ========================================= */

    case FETCH_PARK_DETAILS_REQUEST:
      return {
        ...state,
        parkDetailsLoading: true,
        parkDetailsError: null,
      };

    case FETCH_PARK_DETAILS_SUCCESS:
      return {
        ...state,
        parkDetailsLoading: false,
        parkDetails: action.payload,
      };

    case FETCH_PARK_DETAILS_FAILURE:
      return {
        ...state,
        parkDetailsLoading: false,
        parkDetailsError: action.payload,
      };

    /* =========================================
       CREATE PARK USER
    ========================================= */

    case CREATE_PARK_USER_REQUEST:
      return {
        ...state,
        createUserLoading: true,
        createUserError: null,
      };

    case CREATE_PARK_USER_SUCCESS:
      return {
        ...state,
        createUserLoading: false,
        createdUser: action.payload,
      };

    case CREATE_PARK_USER_FAILURE:
      return {
        ...state,
        createUserLoading: false,
        createUserError: action.payload,
      };

    default:
      return state;
  }
};

export default parkUserReducer;